import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import language from '../../assets/languages/language';
import App_data from '../config/App_data';
import Loader from '../../common/loader';
import { renderHTMLContent } from '../../common/function';

const StatusChangeModel = ({
  change_status,
  className,
  changeModelStatus,
  changeStatusTitle,
  markAsCompleted,
  markNotCompleted,
  markAsNotCompleted,
  markCompleted,
  markCompletedFun,
  changeCompletionStatus,
  summaryDetails,
  showComponent,
  showLoaderOnModel,
}) => {
  let attemptedMarks = 0;
  let totalMarks = 0;
  return (
    <Modal
      isOpen={change_status}
      toggle={() => changeModelStatus()}
      className={'modal-primary complete-or-not-model ' + className}
    >
      <ModalHeader toggle={() => changeModelStatus()}>
        {changeStatusTitle}
      </ModalHeader>
      <ModalBody className={showLoaderOnModel ? 'min-height-150' : ''}>
        {showLoaderOnModel ? (
          <div className='main_loader show_block'>
            <div className='loader-mid'>
              <div className='card-block-loader'>
                <Loader />
              </div>
            </div>
          </div>
        ) : (
          <div className='card-block card-padding'>
            <div className='row'>
              <div className='col-sm-12 text-center'>
                <div className='row'>
                  {/* -------------- Start Image of Mark Completed ------------- */}
                  {showComponent.includes(2) ? (
                    <div className='col-sm-12 col-md-12 '>
                      <div className='quation-img'>
                        <img
                          src={
                            App_data.frontend_url +
                            '/img/question_bank/question_icon_blue.svg'
                          }
                          className='margin_bottom_10'
                          alt=''
                        />
                      </div>
                      <div
                        contentEditable='false'
                        suppressContentEditableWarning={true}
                        className='margin_bottom_10 view_questionhtml bg_blue_status'
                      >
                        {' '}
                        {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}{' '}
                      </div>
                    </div>
                  ) : null}
                  {/* --------------End Image of Mark Completed ------------- */}
                  <div
                    className={`complete-or-not-wrap mx-2 ${showLoaderOnModel ? 'min-height-150' : ''
                      }`}
                  >
                    {/* --------------- Complete Incomplete Field Start -------- */}
                    {showComponent.includes(2) ? (
                      <div className='check-button-wrap mb-2'>
                        <div className='card-actions float-right'>
                          <label className='check_container margin_bottom_0'>
                            {' '}
                            {language.LC().COMPLETED}
                            <input
                              type='checkbox'
                              id='mark_completed'
                              name='mark_completed'
                              value='select'
                              onClick={() => markCompletedFun()}
                              checked={markAsCompleted}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                        <div className='card-actions float-right'>
                          <label className='check_container margin_bottom_0'>
                            {language.LC().NOT_COMPLETED}

                            <input
                              type='checkbox'
                              id='mark_not_completed'
                              name='mark_not_completed'
                              value='select'
                              onClick={() => markNotCompleted()}
                              checked={markAsNotCompleted}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                      </div>
                    ) : null}
                    {/* --------------- Complete Incomplete Field Start -------- */}
                    {/* ---------------- Table ------------------ */}
                    {showComponent.includes(1) ? (
                      <div>
                        {summaryDetails.length ? (
                          <div>
                            <Row className='tbl_row tbl_head'>
                              <Col>#</Col>
                              <Col md='8' sm='8'>
                                Question
                              </Col>
                              <Col>Grading</Col>
                            </Row>

                            {summaryDetails.length &&
                              summaryDetails.map((element, index) => (
                                <Row className='tbl_row' key={element.id}>
                                  <Col>{element.id}</Col>
                                  <Col md='8' sm='8' className='text-left'>
                                    {renderHTMLContent(
                                      element.question &&
                                        element.question.substring(0, 70).includes('$$')
                                        ? element.question
                                        : `${element.question.substring(0, 70)} ...`,
                                      "span",
                                      "summary-text-wrapper"
                                    )}{' '}
                                  </Col>
                                  <span className='d-none'>
                                    {
                                      (attemptedMarks +=
                                        element
                                          .cfa3_essay_case_questions_user_stat
                                          .user_grading_details)
                                    }
                                    {(totalMarks += element.max_grading)}
                                  </span>
                                  <Col>
                                    {
                                      element
                                        .cfa3_essay_case_questions_user_stat
                                        .user_grading_details
                                    }
                                    /{element.max_grading}
                                  </Col>
                                </Row>
                              ))}
                            <Row className='tbl_row tbl_footer'>
                              <Col />
                              <Col md='8' />
                              <Col className='pl-3'>
                                <b>Total : </b>
                                {attemptedMarks}/{totalMarks}
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          <div>
                            <h5 className='mb-1'>
                              You haven't recorded any marks for this yet.{' '}
                            </h5>
                            <h6>
                              Please try answering the questions by clicking on
                              the green icon and grading yourself.
                            </h6>
                          </div>
                        )}
                      </div>
                    ) : null}

                    {/* ---------------- Table ------------------ */}
                    {/* -------------- Submit Button Start -------------- */}
                    {showComponent.includes(2) ? (
                      <div className='d-block text-center complete-quation-submit'>
                        <button
                          disabled={markCompleted}
                          onClick={() => changeCompletionStatus()}
                          className='btn btn-primary pointer_class'
                        >
                          {' '}
                          {language.LC().SUBMIT}{' '}
                        </button>
                      </div>
                    ) : null}
                    {/* -------------- Submit Button End -------------- */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default StatusChangeModel;



// WEBPACK FOOTER //
// ./src/views/Common/StatusChangeModel.js